import { GuestComplimentaryForConfigurationType, GuestEvents } from '@ag-common-lib/public-api';

export function getGuestRegistrationTypeDescription({
  guestEvents,
  complimentaryConfiguration,
  isApplicableForChairmanExtension,
}: {
  guestEvents?: GuestEvents[];
  complimentaryConfiguration?: GuestComplimentaryForConfigurationType;
  isApplicableForChairmanExtension?: boolean;
}): string {
  const events = guestEvents?.length ? guestEvents : [GuestEvents.main];

  const descriptions = events.map(event => {
    const isComplimentary = complimentaryConfiguration?.[event] ?? false;
    let description = `${isComplimentary ? 'Complimentary' : 'Additional'} Guest`;

    if (isApplicableForChairmanExtension) {
      switch (event) {
        case GuestEvents.main:
          description += ' (Conf.)';
          break;
        case GuestEvents.chairmanExtension:
          description += ' (Chairman Ext.)';
          break;
      }
    }

    return description;
  });

  return descriptions.join('; ');
}
